<div class="position-relative search-filters" *ngFor="let key of Object.keys(dropdownObject); let i = index;">
    <ng-container *ngIf="(dropdownObject[key].length > 0)">
        <app-multi-select-dropdown
            [label]="key"
            [data]="dropdownObject[key]"
            id="{{'multiselect-'+i}}"
            [isadvance]="true"
            [dropdownSettings]="dropdownSettings"
            (SelectEvent)="onSelectOption($event)"
            (checkBoxSelectEvent)="onCheckboxSelectEvent($event)">
        </app-multi-select-dropdown>
    </ng-container>
</div>